{<template>
  <v-content>
    <v-container class="fill-height">
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12">
          <v-row>
            <v-col md="7">
              <div
                class="text-center mb-3"
                v-if="$vuetify.breakpoint.smAndDown"
              >
                <v-img
                  src="@/assets/home.svg"
                  width="350"
                ></v-img>
              </div>
              <div
                class="mb-5"
                style="color:#616161"
              >
                <h1 class="display-1 font-weight-bold mb-1">Skyware ERP</h1>
                <h1 class="display-1 font-weight mb-4">{{$t('home.transform_data_to_decision')}}</h1>
                <h4 class="">{{$t('home.Modernize your organization and take control of your business')}}</h4>
              </div>
              <div class="text-center">
                <v-img
                  src="@/assets/home.svg"
                  width="550"
                  v-if="$vuetify.breakpoint.smAndUp"
                ></v-img>
              </div>
            </v-col>
            <v-col md="5">
              <register></register>
            </v-col>
            <services class="mt-10"></services>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

  </v-content>
</template>

<script>
// @ is an alias to /src
// https://lateralinnovations.com/en/
import Register from "./register/Register";
import Services from "./landing/Services";

export default {
  name: "home",
  data: function () {
    return {
      LogoSource: "../assets/logo.png"
    };
  },
  computed: {
    GetWindowHeight () {
      return window.innerHeight - 80;
    }
  },
  components: {
    Register, Services
  }
};
</script>